import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface Director {
  first_name: string
  last_name: string
  email: string
  position: string
  address: string
  city: string
  state: string
  zip_code: string | null
  country: string
  country_code: string
  mobile: string | null
  mobileCode: string
  dob: string
  nationality: string
  gender: string
  identity_type: string | null
  identity_number: string
  identity_issuing_country: string | null
  identity_issuing_date: string | null
  identity_expiry_date: string | null
  tax_number: string | null
  tax_issuing_country: string | null
  shares_in_organization: string | null
  date_of_appointment: string | null
  date_of_termination: string | null
  house_number: string | null
  pep: string | null
  bvn: string | null
}

interface CACVerificationData {
  businessName: string
  businessRegistrationNumber: string
  businessAddress: string
  businessState: string
  businessCity: string
  businessCountry: string | null
  businessCategory: string
  businessRegisteredDate: string
  businessActivityDescription: string | null
  businessMobile: string | null
  businessTaxNumber: string | null
  businessTaxIssuingCountry: string | null
  website: string | null
  businessRegisteredCountry: string | null
  businessCountryCode: string | null
  businessMobileCode: string | null
  businessZipcode: string | null
  businessHouseNumber: string | null
  businessScale: string | null
  annualTurnover: string | null
  industrySector: string | null
  countryOfOperation: string | null
  totalEmployees: string | null
  businessApplicantEmail: string | null
  directors: Director[]
}

interface CACVerificationState {
  data: CACVerificationData | null
  isLoading: boolean
  error: string | null
}

const initialState: CACVerificationState = {
  data: null,
  isLoading: false,
  error: null,
}

const cacVerificationSlice = createSlice({
  name: "cacVerification",
  initialState,
  reducers: {
    setCACVerificationData: (state, action: PayloadAction<CACVerificationData>) => {
      state.data = action.payload
      state.error = null
    },
    setCACVerificationLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCACVerificationError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.isLoading = false
    },
    resetCACVerification: () => initialState,
  },
})

export const { setCACVerificationData, setCACVerificationLoading, setCACVerificationError, resetCACVerification } =
  cacVerificationSlice.actions

export default cacVerificationSlice.reducer
